<template>
  <section>
    <ValidationObserver v-slot="{ valid }">
      <a-card :title="$t('Questionnaire')">
        <p>
          {{ $t("questionnaire_subtitle") }}
        </p>
        <br />
        <a-row :gutter="16">
          <a-col :span="24">
            <h4>{{ $t("is_sanctioned[0]") }}</h4>
            <p>{{ $t("is_sanctioned[1]") }}</p>
            <a-select
              showArrow
              :size="$store.state.clientInfo.uiSize"
              :getPopupContainer="() => $root.$el"
              v-model="is_sanctioned"
              class="select_y_n"
            >
              <a-icon slot="suffixIcon" type="caret-up" theme="filled" />
              <a-select-option value="No">{{ $t("No") }}</a-select-option>
              <a-select-option value="Yes">{{ $t("Yes") }}</a-select-option>
            </a-select>
          </a-col>
        </a-row>
        <br />
        <a-row :gutter="16">
          <a-col :span="24">
            <h4>
              {{ $t("beneficial_government") }}
            </h4>
            <a-select
              showArrow
              :size="$store.state.clientInfo.uiSize"
              :getPopupContainer="() => $root.$el"
              v-model="is_officer"
              class="select_y_n"
            >
              <a-icon slot="suffixIcon" type="caret-up" theme="filled" />
              <a-select-option value="No">{{ $t("No") }}</a-select-option>
              <a-select-option value="Yes">{{ $t("Yes") }}</a-select-option>
            </a-select>
          </a-col>
        </a-row>
        <br />
        <a-row :gutter="16">
          <a-col :span="24">
            <h4>
              {{ $t("is_government") }}
            </h4>
            <a-select
              :size="$store.state.clientInfo.uiSize"
              :getPopupContainer="() => $root.$el"
              v-model="related_officer"
              class="select_y_n"
            >
              <a-icon slot="suffixIcon" type="caret-up" theme="filled" />
              <a-select-option value="No">{{ $t("No") }}</a-select-option>
              <a-select-option value="Yes">{{ $t("Yes") }}</a-select-option>
            </a-select>
          </a-col>
        </a-row>
        <br />
        <a-row :gutter="16">
          <a-col :span="24">
            <h4>{{ $t("Purpose") }}</h4>
            <ValidationProvider
              :name="$t('Purpose')"
              rules="required"
              :immediate="immediate"
              mode="eager"
              v-slot="slotProps"
            >
              <a-form-item
                has-feedback
                :validate-status="resolveState(slotProps)"
                :help="slotProps.errors[0]"
              >
                <a-textarea
                  :placeholder="$t('Purpose Placeholder')"
                  :rows="4"
                  v-model="purpose"
                />
              </a-form-item>
            </ValidationProvider>
          </a-col>
        </a-row>
        <p></p>
        <a-row :gutter="16">
          <a-col :span="24">
            <h4>{{ $t("Nature Business") }}</h4>
            <ValidationProvider
              :name="$t('Nature Business')"
              rules="required"
              :immediate="immediate"
              mode="eager"
              v-slot="slotProps"
            >
              <a-form-item
                has-feedback
                :validate-status="resolveState(slotProps)"
                :help="slotProps.errors[0]"
              >
                <a-textarea
                  :placeholder="$t('Nature Business Placeholder')"
                  :rows="4"
                  v-model="business"
                />
              </a-form-item>
            </ValidationProvider>
          </a-col>
        </a-row>
        <p></p>
        <a-row :gutter="16">
          <a-col :span="24">
            <h4>{{ $t("Source Funds") }}</h4>
            <ValidationProvider
              :name="$t('Source Funds')"
              rules="required"
              :immediate="immediate"
              mode="eager"
              v-slot="slotProps"
            >
              <a-form-item
                has-feedback
                :validate-status="resolveState(slotProps)"
                :help="slotProps.errors[0]"
              >
                <a-textarea
                  :placeholder="$t('Source Funds Placeholder')"
                  :rows="4"
                  v-model="sourceFunds"
                />
              </a-form-item>
            </ValidationProvider>
          </a-col>
        </a-row>
        <p></p>
        <a-row :gutter="16">
          <a-col :span="24">
            <h4>{{ $t("Additional Information comments for us") }}</h4>
            <ValidationProvider
              :name="$t('Additional Information comments for us')"
              rules="required"
              :immediate="immediate"
              mode="eager"
              v-slot="slotProps"
            >
              <a-form-item
                has-feedback
                :validate-status="resolveState(slotProps)"
                :help="slotProps.errors[0]"
              >
                <a-textarea
                  :placeholder="$t('Additional Information Placeholder')"
                  :rows="4"
                  v-model="additionalInfo"
                />
              </a-form-item>
            </ValidationProvider>
          </a-col>
        </a-row>
      </a-card>
      <btm-step-nav-institution
        :passed="valid"
        @submitForm="submitForm"
      ></btm-step-nav-institution>
    </ValidationObserver>
  </section>
</template>

<script>
import {
  Card,
  Form,
  Button,
  Input,
  Row,
  Col,
  Select,
  Icon
} from "ant-design-vue";
import BtmStepNavInstitution from "@/components/BtmStepNavInstitution";
import { getCompanyQuestionnaire, submitCompanyQuestionnarie } from "@/api/kyc";
import { displayErrors } from "@/utils";

export default {
  name: "Questionnaire",
  data() {
    return {
      is_sanctioned: "No",
      is_officer: "No",
      related_officer: "No",
      purpose: "",
      business: "",
      sourceFunds: "",
      additionalInfo: "",
      immediate: false
    };
  },
  components: {
    [Card.name]: Card,
    [Button.name]: Button,
    [Input.name]: Input,
    [Input.TextArea.name]: Input.TextArea,
    [Form.name]: Form,
    [Form.Item.name]: Form.Item,
    [Row.name]: Row,
    [Col.name]: Col,
    [Select.name]: Select,
    [Select.Option.name]: Select.Option,
    [Icon.name]: Icon,
    BtmStepNavInstitution
  },

  methods: {
    resolveState({ errors, pending, valid }) {
      if (errors[0]) {
        return "error";
      }
      if (pending) {
        return "validating";
      }
      if (valid) {
        return "success";
      }
      return "";
    },
    async submitForm(callBack) {
      let params = {
        connect_with_sanctioned_countries: this.is_sanctioned,
        is_officer: this.is_officer,
        related_officer: this.related_officer,
        purpose: this.purpose,
        nature_of_business: this.business,
        source_of_funds: this.sourceFunds,
        comments: this.additionalInfo
      };
      try {
        await submitCompanyQuestionnarie(params);
        callBack(true);
      } catch (err) {
        callBack(false);
        displayErrors(err);
      }
    },
    async fetchData() {
      try {
        const data = await getCompanyQuestionnaire();
        this.is_sanctioned = data.connect_with_sanctioned_countries || "No";
        this.is_officer = data.is_officer || "No";
        this.related_officer = data.related_officer || "No";
        this.purpose = data.purpose || "";
        this.business = data.nature_of_business || "";
        this.sourceFunds = data.source_of_funds || "";
        this.additionalInfo = data.comments || "";
        this.immediate = true;
      } catch (err) {
        displayErrors(err);
      }
    }
  },
  created() {
    this.fetchData();
  }
};
</script>

<style scoped></style>
